<template>
  <b-container>
    <b-row align-h="center">
      <b-col md="8">
        <b-card>
          <b-badge :variant="statusVariant(this.status)" class="mb-1">
            <span v-if="this.status === 1">Menunggu Proses</span>
            <span v-else-if="this.status === 2">Dalam Proses</span>
            <span v-else-if="this.status === 3">Ditolak</span>
            <span v-else-if="this.status === 4">Selesai</span>
            <span v-else-if="this.status === 5">Dalam Perbaikan</span>
          </b-badge>
          <b-form v-on:submit.prevent>
            <b-row>
              <b-col md="8">
                <b-form-group label="Nama Pelanggan" label-for="name">
                  <b-form-input id="name" v-model="form.name" readonly />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Tanggal Permintaan" label-for="date">
                  <b-form-input
                    id="name"
                    v-model="form.date"
                    readonly
                  /> </b-form-group
              ></b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <b-form-group label="Jenis Part" label-for="part">
                  <b-form-input id="part" v-model="form.typeName" readonly />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Kilometer" label-for="mileage">
                  <b-form-input id="mileage" v-model="form.mileage" readonly />
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="Deskripsi" label-for="description">
              <b-form-textarea
                id="description"
                placeholder="Deskripsi"
                v-model="form.description"
                readonly
              />
            </b-form-group>
            <b-row>
              <b-col md="6">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-success"
                  block
                  class="my-1"
                  @click="toWhatsApp()"
                >
                  Hubungi Pelanggan
                </b-button>
              </b-col>
              <b-col md="6">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  block
                  v-b-modal.modal-photo
                  class="my-1"
                >
                  Lihat Foto
                </b-button>
                <b-modal
                  id="modal-photo"
                  ok-only
                  ok-title="close"
                  centered
                  size="lg"
                  title="Foto"
                  class="text-center"
                >
                  <b-img
                    id="photo"
                    :src="photo"
                    width="1000px"
                    fluid
                    alt="trouble photo"
                  />
                </b-modal>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
        <b-row v-if="status === 1">
          <b-col>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="danger"
              class="mr-1"
              block
              v-b-modal.modal-reject
            >
              Tolak
            </b-button>
          </b-col>
          <b-col>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1"
              block
              v-b-modal.modal-process
            >
              Proses
            </b-button>
          </b-col>
        </b-row>

        <b-row v-if="status === 4">
          <b-col>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="danger"
              class="mr-1"
              block
              @click="maintenance()"
            >
              Penggantian Part Tertunda
            </b-button>
          </b-col>
        </b-row>

        <b-card v-if="status === 2">
          <b-row>
            <b-col>
              <label for="details" class="font-weight-bold mb-1"
                >Surat Perintah Kerja</label
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="mb-1"
                @click="openFile()"
              >
                <feather-icon icon="FileIcon" class="mr-1" />
                <span class="align-middle">{{ form.file }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
        <b-row v-if="status === 2 || status === 5">
          <b-col v-if="status === 2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="danger"
              class="mr-1"
              block
              @click="maintenance()"
            >
              Penggantian Part > 1 Hari
            </b-button>
          </b-col>
          <b-col>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1"
              block
              @click="finish()"
            >
              Selesai
            </b-button>
          </b-col>
        </b-row>
        <b-card v-if="status === 3">
          <b-form-group label="Alasan Penolakan" label-for="reject_reason">
            <b-form-textarea
              id="reject_reason"
              placeholder="Alasan Penolakan"
              v-model="form.reject_reason"
              disabled
            />
          </b-form-group>
        </b-card>
      </b-col>
      <b-col md="4" v-if="form.unit_id != null">
        <b-card>
          <b-row>
            <b-col md="12" class="mb-1">
              <label for="details" class="text-primary font-weight-bold"
                >Detail Unit</label
              >
            </b-col>
            <b-col md="12" class="mb-2">
              <b-img
                id="image"
                :src="unit.image"
                fluid
                alt="Unit Image"
                v-b-modal.modal-lg
              />
              <b-modal
                id="modal-lg"
                ok-only
                ok-title="close"
                centered
                size="lg"
                title="Large Modal"
                class="text-center"
              >
                <b-img
                  id="image"
                  :src="unit.image"
                  width="1000px"
                  fluid
                  alt="Unit image"
                />
              </b-modal>
            </b-col>
            <b-col md="12">
              <b-row>
                <b-col md="4"> Nopol </b-col>
                <b-col md="8" class="text-right font-weight-bolder">
                  {{ unit.police_no }}
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col md="4"> Nama </b-col>
                <b-col md="8" class="text-right font-weight-bolder">
                  {{ unit.name }}
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col md="6"> Kilometer terakhir </b-col>
                <b-col md="6" class="text-right font-weight-bolder">
                  {{ formatNumber(unit.mileage) }} km
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col>
                  <router-link :to="'/unit/' + unit.id">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-primary"
                      block
                      class="my-1"
                    >
                      Lihat Detail
                    </b-button>
                  </router-link>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col md="8"> </b-col>

      <b-modal
        id="modal-reject"
        title="Penolakan Permintaan"
        ok-title="Kirim"
        cancel-variant="outline-secondary"
        centered
        hide-footer
      >
        <validation-observer ref="loginValidation">
          <b-form ref="form" @submit.prevent>
            <b-form-group
              :state="errors"
              label="Alasan Penolakan"
              label-for="reject"
              invalid-feedback="Alasan penolakan tidak boleh kosong"
            >
              <validation-provider
                #default="{ errors }"
                name="reject"
                rules="required"
              >
                <b-form-textarea
                  id="reject"
                  name="reject"
                  type="text"
                  v-model="form.reject_reason"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Alasan Penolakan"
                  required="required"
                />
                <small class="text-danger">{{ errors[0] || errMessage }}</small>
              </validation-provider>
            </b-form-group>

            <b-row>
              <b-col>
                <b-button
                  class="mt-1 mb-2"
                  type="submit"
                  variant="danger"
                  block
                  @click="reject()"
                >
                  Kirim
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>

      <b-modal
        id="modal-process"
        title="Info Bengkel"
        ok-title="Kirim"
        cancel-variant="outline-secondary"
        centered
        hide-footer
      >
        <validation-observer>
          <b-form ref="form" @submit.prevent>
            <b-row>
              <b-col>
                <b-form-group label="Pilih Bengkel" label-for="workshop">
                  <v-select
                    id="workshop"
                    v-model="selectedWorkshop"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="optionWorkshops"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!selectedWorkshop"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Upload file SPK" label-for="File">
                  <b-form-file
                    v-model="file"
                    placeholder="Upload file disini..."
                    drop-placeholder="Upload file disini..."
                    id="extension"
                    accept=".pdf"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="note" label-for="note">
                  <b-form-textarea
                    id="note"
                    placeholder="Note"
                    v-model="note"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button
                  class="mt-1 mb-2"
                  type="submit"
                  variant="success"
                  block
                  @click="process()"
                >
                  Proses
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
    </b-row>
  </b-container>
</template>

<script>
import {
  BFormTextarea,
  BBadge,
  BImg,
  BFormTimepicker,
  BFormDatepicker,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BContainer,
  BFormFile,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import flatPickr from "vue-flatpickr-component";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import moment from "moment";

export default {
  components: {
    ToastificationContent,
    flatPickr,
    Cleave,
    BFormTextarea,
    BBadge,
    ValidationProvider,
    ValidationObserver,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    BImg,
    BFormTimepicker,
    BFormDatepicker,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    draggable,
    Prism,
    BContainer,
    vSelect,
    BFormFile,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        name: "",
        description: "",
        reject_reason: "",
        location: "",
        latitude: "",
        longitude: "",
        phone: "",
        mileage: "",
        file: null,
        unit_id: "",
        typeName: "",
        note: "",
      },
      unit: {
        image: "",
        name: "",
        police_no: "",
        mileage: "",
      },
      status: "",
      photo: "",
      permissions: [],
      errors: "",
      errMessage: "",
      optionWorkshops: [],
      selectedWorkshop: null,
      workshop: null,
      file: null,
      note: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-warning",
        2: "light-primary",
        3: "light-danger",
        4: "light-success",
        5: "light-primary",
      };

      return (status) => statusColor[status];
    },
  },
  setup() {
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
    this.getWorkshop();
  },
  methods: {
    moment(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm");
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    formatNumber(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "decimal",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(value);
    },
    getDetails() {
      const id = this.$route.params.id;
      const { baseUrl } = $themeConfig.app;
      const imageUri = baseUrl + "image/request/part-replacement/";

      this.$http
        .get("request/part-replacement/" + id)
        .then((response) => {
          this.status = response.data.data.status;
          this.form.name = response.data.data.customer.name;
          this.form.location = response.data.data.location;
          this.form.latitude = response.data.data.latitude;
          this.form.longitude = response.data.data.longitude;
          this.form.date = this.moment(response.data.data.created_at);
          this.form.description = response.data.data.description;
          this.form.reject_reason = response.data.data.reject_reason;
          this.form.phone = response.data.data.customer.phone;
          this.form.mileage =
            this.formatNumber(response.data.data.mileage) + " km";
          this.form.unit_id = response.data.data.unit_id;
          this.photo = imageUri + response.data.data.image;
          this.form.file = response.data.data.file;
          this.form.typeName = response.data.data.type_name;
          this.form.note = response.data.data.note;

          let $unit = response.data.data.unit;
          this.unit.id = $unit.id;
          this.unit.image = baseUrl + "image/unit/" + $unit.image;
          this.unit.name = $unit.name;
          this.unit.mileage = $unit.mileage;
          this.unit.police_no = $unit.police_no;

          let $workshop = response.data.data.workshop;
          this.workshop = $workshop;
        })
        .catch((errors) => {
          console.log(errors.response);
        });
    },
    process() {
      const id = this.$route.params.id;
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("note", this.note);
      formData.append("workshop_id", this.selectedWorkshop.value);

      this.$http
        .post("request/part-replacement/" + id + "/process", formData)
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: "Permintaan penggantian part diproses",
              variant: "success",
            },
          });
          location.href = "/request/part-replacements";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    finish() {
      const id = this.$route.params.id;
      this.$http
        .post("request/part-replacement/" + id + "/finish")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: "Permintaan penggantian part selesai",
              variant: "success",
            },
          });
          location.href = "/request/part-replacements";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },

    maintenance() {
      const id = this.$route.params.id;
      this.$http
        .post("request/part-replacement/" + id + "/maintenance")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: "Unit Dalam Perbaikan",
              variant: "success",
            },
          });
          location.href = "/request/part-replacements";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },

    reject() {
      const id = this.$route.params.id;
      this.$http
        .post("request/part-replacement/" + id + "/reject", {
          reject_reason: this.form.reject_reason,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: "Permintaan penggantian part ditolak",
              variant: "danger",
            },
          });
          location.href = "/request/part-replacements";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    toWhatsApp() {
      const phone = this.form.phone;
      var uri = "https://wa.me/62" + phone.substring(1);
      window.open(uri, "_blank", "noreferrer");
    },
    getWorkshop() {
      this.$http.get("place/workshops").then((response) => {
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.optionWorkshops.push($data);
        }
        // console.log(this.form.optionsOrganization)
      });
    },
    openFile() {
      const { baseUrl } = $themeConfig.app;
      const fileUri = baseUrl + "file/request/part-replacement/spk/";
      var uri = fileUri + this.form.file;
      window.open(uri, "_blank", "noreferrer");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>